import React from 'react';
import { NavLink } from 'react-router-dom';
import './Nav.css';

const NavLinks = (props) => {
  return ( 
    <li className={props.className}>
      <NavLink
        className={({ isActive }) => isActive ? "nav_link active" : "nav_link"}
        to={props.to}
      >
        {props.text}
      </NavLink>
    </li>
  );
}

export default NavLinks;